import React from 'react';
import { usePopupManager, useShowContextRequired } from 'ui-builder';
import { ConfirmDeletePopup, IconButton, IconType } from 'features/nekst-widgets';
import { DocumentsTemplate, useDocumentsTemplatesService } from 'nekst-api';

function ConfirmTemplateDeletePopup(
  props: {
    data: DocumentsTemplate,
  },
) {
  const service = useDocumentsTemplatesService();

  return (
    <ConfirmDeletePopup
      deleteFunc={() => service.deleteDocumentsTemplate(props.data.id)}
      message={`Are you sure you want to delete template "${props.data.name}"?`}
    />
  );
}

export default function DeleteTemplateButton() {
  const showContext = useShowContextRequired<DocumentsTemplate>();

  const popupManager = usePopupManager();

  return (
    <IconButton
      title="Delete Template"
      onClick={
        () => popupManager.openPopup(
          <ConfirmTemplateDeletePopup data={showContext.data} />,
        )
      }
      type={IconType.TRASH_CAN}
    />
  );
}
